import UploadFileVue from './main.vue';

var UploadFile = {};

UploadFile.install = function (Vue) {
  var UploadFileConstructor = Vue.extend(UploadFileVue);
  var instance = new UploadFileConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);

  Vue.prototype.$wkUploadFile = instance;
};

export default UploadFile;